import {trackAmplitudeEvent} from "@pg-mono/amplitude";
import {gtmEcommerceOfferTypeMap, OfferType} from "@pg-rp/common-types";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {getCurrency} from "../../../utils/get_currency";
import {View} from "../../km_app/types/View";
import {getApplicationSourceSectionDisplay} from "../../lead/hooks/get_application_source_section_display";
import {ApplicationSourceSection} from "../../lead/types/ApplicationSourceSection";
import {IPropertyListItemDTO} from "../../properties/types/IPropertyListItemDTO";
import {getGtmEcommerceListDetailsByViewType} from "../gtm/ecommerce/common/get_gtm_ecommerce_list_details_by_view_type";
import {getAmplitudeItemIdProperties} from "./get_amplitude_item_id_properties";

export enum AmplitudeLeadOrigin {
    COMPARATOR_OFFER = 42,
    COMPARATOR_PROPERTY = 43
}

interface ILeadPayload {
    property?: number;
    offer?: number;
}

const getAmplitudeLeadOrigin = (sentPayload: ILeadPayload): AmplitudeLeadOrigin | undefined => {
    if (sentPayload.offer != null) {
        return AmplitudeLeadOrigin.COMPARATOR_OFFER;
    }
    if (sentPayload.property != null) {
        return AmplitudeLeadOrigin.COMPARATOR_PROPERTY;
    }
    return undefined;
};

interface ITrackAmplitudePurchaseParams {
    property: IPropertyListItemDTO | IPropertyDetailDTO;
    leadUuid: string;
    viewType: View;
    sourceSection?: ApplicationSourceSection;
    inquirySource?: string;
    leadOriginPayload?: ILeadPayload;
}

export const trackAmplitudePurchase = (params: ITrackAmplitudePurchaseParams) => {
    const {property, leadUuid, viewType, sourceSection, inquirySource, leadOriginPayload} = params;
    const offerType = (property.type || property.offer.type) as OfferType;
    const {item_list_name} = getGtmEcommerceListDetailsByViewType(viewType);

    const eventProperties: Record<string, string | number> = {
        transaction_id: leadUuid,
        currency: getCurrency({country: property.region.country, ISOCodeFormat: true}),
        ...getAmplitudeItemIdProperties({offerId: property.offer.rp_id || property.offer.gh_id, propertyId: property.rp_id || property.gh_id}),
        item_name: property.offer.name,
        item_brand: property.offer.vendor.name,
        item_category: "property",
        item_type: gtmEcommerceOfferTypeMap[offerType],
        item_list_name,
        inquiry_source: getPurchaseInquirySource({viewType, inquirySource, sourceSection}),
        variant_name: property.flat_number,
        variant_area: property.area,
        variant_rooms: property.rooms,
        event_category: getPurchaseEventCategoryByView(viewType)
    };

    if (property.price != null) {
        eventProperties.price = property.price;
    }

    if (property.region.full_name) {
        eventProperties.item_category2 = property.region.full_name;
    }

    if (property.floor != null) {
        eventProperties.variant_floor = property.floor;
    }

    if (viewType === View.COMPARATOR && leadOriginPayload != null) {
        const leadOrigin = getAmplitudeLeadOrigin(leadOriginPayload);
        if (leadOrigin != null) {
            eventProperties.lead_origin = leadOrigin;
        }
    }

    trackAmplitudeEvent("purchase", eventProperties);
};

const getPurchaseEventCategoryByView = (viewType: View): string => {
    switch (viewType) {
        case View.FAVORITE:
            return "km_favourites";
        case View.COMPARATOR:
            return "km_offer_comparison";
        default:
            return "homematch";
    }
};

const getPurchaseInquirySource = (params: {viewType: View; inquirySource?: string; sourceSection?: ApplicationSourceSection}): string => {
    const {viewType, inquirySource, sourceSection} = params;

    if (viewType === View.FAVORITE) {
        return "km_favourites";
    }

    if (viewType === View.COMPARATOR) {
        return "km_offer_comparison";
    }

    return inquirySource ?? (sourceSection != null ? getApplicationSourceSectionDisplay(sourceSection) : "");
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";
import {gtmEcommerceOfferTypeMap, OfferType} from "@pg-rp/common-types";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {getCurrency} from "../../../utils/get_currency";
import {View} from "../../km_app/types/View";
import {getApplicationSourceSectionDisplay} from "../../lead/hooks/get_application_source_section_display";
import {ApplicationSourceSection} from "../../lead/types/ApplicationSourceSection";
import {IPropertyListItemDTO} from "../../properties/types/IPropertyListItemDTO";
import {getGtmEcommerceListDetailsByViewType} from "../gtm/ecommerce/common/get_gtm_ecommerce_list_details_by_view_type";
import {getAmplitudeItemIdProperties} from "./get_amplitude_item_id_properties";

export enum AmplitudeLeadOrigin {
    COMPARATOR_OFFER = 42,
    COMPARATOR_PROPERTY = 43
}

interface ILeadPayload {
    property?: number;
    offer?: number;
}

const getAmplitudeLeadOrigin = (sentPayload: ILeadPayload): AmplitudeLeadOrigin | undefined => {
    if (sentPayload.offer != null) {
        return AmplitudeLeadOrigin.COMPARATOR_OFFER;
    }
    if (sentPayload.property != null) {
        return AmplitudeLeadOrigin.COMPARATOR_PROPERTY;
    }
    return undefined;
};

interface ITrackAmplitudePurchaseParams {
    property: IPropertyListItemDTO | IPropertyDetailDTO;
    leadUuid: string;
    viewType: View;
    sourceSection?: ApplicationSourceSection;
    inquirySource?: string;
    leadOriginPayload?: ILeadPayload;
}

export const trackAmplitudePurchase = (params: ITrackAmplitudePurchaseParams) => {
    const {property, leadUuid, viewType, sourceSection, inquirySource, leadOriginPayload} = params;
    const offerType = (property.type || property.offer.type) as OfferType;
    const {item_list_name} = getGtmEcommerceListDetailsByViewType(viewType);

    const eventProperties: Record<string, string | number> = {
        transaction_id: leadUuid,
        currency: getCurrency({country: property.region.country, ISOCodeFormat: true}),
        ...getAmplitudeItemIdProperties({offerId: property.offer.rp_id || property.offer.gh_id, propertyId: property.rp_id || property.gh_id}),
        item_name: property.offer.name,
        item_brand: property.offer.vendor.name,
        item_category: "property",
        item_type: gtmEcommerceOfferTypeMap[offerType],
        item_list_name,
        inquiry_source: getPurchaseInquirySource({viewType, inquirySource, sourceSection}),
        variant_name: property.flat_number,
        variant_area: property.area,
        variant_rooms: property.rooms,
        event_category: getPurchaseEventCategoryByView(viewType)
    };

    if (property.price != null) {
        eventProperties.price = property.price;
    }

    if (property.region.full_name) {
        eventProperties.item_category2 = property.region.full_name;
    }

    if (property.floor != null) {
        eventProperties.variant_floor = property.floor;
    }

    if (viewType === View.COMPARATOR && leadOriginPayload != null) {
        const leadOrigin = getAmplitudeLeadOrigin(leadOriginPayload);
        if (leadOrigin != null) {
            eventProperties.lead_origin = leadOrigin;
        }
    }

    trackAmplitudeEvent("purchase", eventProperties);
};

const getPurchaseEventCategoryByView = (viewType: View): string => {
    switch (viewType) {
        case View.FAVORITE:
            return "km_favourites";
        case View.COMPARATOR:
            return "km_offer_comparison";
        default:
            return "homematch";
    }
};

const getPurchaseInquirySource = (params: {viewType: View; inquirySource?: string; sourceSection?: ApplicationSourceSection}): string => {
    const {viewType, inquirySource, sourceSection} = params;

    if (viewType === View.FAVORITE) {
        return "km_favourites";
    }

    if (viewType === View.COMPARATOR) {
        return "km_offer_comparison";
    }

    return inquirySource ?? (sourceSection != null ? getApplicationSourceSectionDisplay(sourceSection) : "");
};
